// Utility to navigate to a section on the home page from any route
export function navigateToHomeSection(href) {
  try {
    // normalize to '#id' form
    const hashIndex = href.indexOf('#');
    const id = hashIndex !== -1 ? href.slice(hashIndex) : href;

    // BrowserRouter uses clean paths; preserve the section hash while returning home.
    const currentPath = window.location.pathname;
    const scrollToElement = (el) => {
      const top = el.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, behavior: 'smooth' });
    };

    const findAndScroll = () => {
      const el = document.querySelector(id);
      if (el) {
        scrollToElement(el);
        return true;
      }
      return false;
    };

    const ensureHomeThenScroll = () => {
      // Try immediately, then poll until timeout
      if (findAndScroll()) return;

      const start = Date.now();
      const interval = setInterval(() => {
        if (findAndScroll()) {
          clearInterval(interval);
          return;
        }
        if (Date.now() - start > 1000) {
          clearInterval(interval);
        }
      }, 50);
    };

    // If we're not on the home route, switch to it first.
    if (currentPath !== '/') {
      window.history.pushState({}, '', `/${id}`);
      window.dispatchEvent(new PopStateEvent('popstate'));
      // allow routing to update, then poll for element
      setTimeout(ensureHomeThenScroll, 50);
    } else {
      ensureHomeThenScroll();
    }
  } catch (e) {
    console.error('navigateToHomeSection error', e);
  }
}
